import React from 'react';

import {Button, Icon} from '@deviceinsight/ng-ui-basic-components';
import {GridColorPicker} from '@deviceinsight/ng-ui-components';

import {Trans, StyleApi} from '@deviceinsight/ng-ui-scale-lib/api';
import {Zone} from '../types';
import './ZoneEdit.scss';

type Props = {
	zone: Zone;
	zones: Array<Zone>;
	index: number;
	onZonesChange: (arg0: Array<Zone>) => void;
};

const updateZones = (zone: Zone, index: number, zones: Array<Zone>): Array<Zone> => {
	const updatedZones = [...zones];
	updatedZones[index] = zone;
	return updatedZones;
};

const spliceZones = (zoneIndex: number, zones: Array<Zone>): Array<Zone> => {
	return zones.reduce<Zone[]>((reducedZones, zone, index) => {
		if (index !== zoneIndex) reducedZones.push(zone);
		return reducedZones;
	}, []);
};

const ZoneEdit = ({zone, index, zones, onZonesChange}: Props) => {
	const {value, color} = zone;
	return (
		<div className="kpi-zone fields">
			{index < zones.length - 1 ? (
				<div className="field value-select">
					{index === 0 && (
						<label>
							<Trans i18nKey="dashboard.widgets.kpisinglevalue.config.untilvalue">Until value:</Trans>
						</label>
					)}
					<input
						type="number"
						value={value || 0}
						min={index > 0 ? zones[index - 1].value : ''}
						max={zones[zones.length - 1].value}
						onChange={({target: {value}}: React.ChangeEvent<HTMLInputElement>) =>
							onZonesChange(
								updateZones(
									{
										color,
										value: parseInt(value, 10)
									},
									index,
									zones
								)
							)
						}
						className="zone-value"
					/>
				</div>
			) : (
				<div className="field value-select">
					{index === 0 && (
						<label>
							<Trans i18nKey="dashboard.widgets.kpisinglevalue.config.untilvalue">Until value:</Trans>
						</label>
					)}
					<input type="text" value="&infin;" disabled={true} className="zone-value" />
				</div>
			)}
			<div className="field color-select">
				{index === 0 && (
					<label>
						<Trans i18nKey="dashboard.widgets.kpisinglevalue.config.showcolor">Display with color:</Trans>
					</label>
				)}
				<GridColorPicker
					inline={false}
					colors={StyleApi.getColorPalette()}
					value={color}
					onPick={(color) =>
						onZonesChange(
							updateZones(
								{
									color,
									value
								},
								index,
								zones
							)
						)
					}
				/>
			</div>

			<div className="field">
				{index === 0 && (
					<label>
						<Trans i18nKey="dashboard.widgets.kpisinglevalue.config.remove">Remove:</Trans>
					</label>
				)}
				{index !== zones.length - 1 && (
					<Button naked onClick={() => onZonesChange(spliceZones(index, zones))}>
						<Icon del />
					</Button>
				)}
			</div>
		</div>
	);
};

export default ZoneEdit;
